<script lang="ts">
	import Seo from '$lib/seo/Seo.svelte';
	import type { PageProps } from './$types';

	let { data }: PageProps = $props();

	const entry = $derived(data.route.kind === 'page' ? data.route.page : undefined);
	/**
	 * Resolved in `+page.ts`, not here. A server load cannot serialise a
	 * component, but the universal one can await a dynamic import — which is
	 * what keeps the other thirty-four registry pages out of this bundle.
	 */
	const Body = $derived(data.body);
</script>

{#if entry}
	<Seo
		title={entry.title}
		description={entry.description}
		path={entry.path}
		locale={entry.locale}
		alternates={data.alternates}
	/>
{/if}

{#if Body}
	<Body products={data.products} productCount={data.productCount} />
{/if}
